export default "__VITE_ASSET__CKn9tqoz__"